import React from 'react';
import classNames from 'classnames';
import { Icon } from '@/hybrid/core/Icon.atom';

interface SortIconProps {
  sortBy: string;
  sortAsc: boolean;
  sortProperty: string;
}

/** Icon to indicate sorting, e.g. table column headers */
export const SortIcon: React.FunctionComponent<SortIconProps> = ({ sortProperty, sortBy, sortAsc }) => (
  <Icon
    testId={`sortProperty_${sortProperty}`}
    icon={classNames({
      'fa-sort-asc': sortBy === sortProperty && sortAsc,
      'fa-sort-desc': sortBy === sortProperty && !sortAsc,
      'fa-sort': sortBy !== sortProperty,
    })}
    type={sortBy === sortProperty ? 'info' : 'dark-gray'}
    extraClassNames="ml5 cursorPointer"
  />
);
